import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import type React from 'react'
import type { ReactElement } from 'react'
import { Tooltip } from '../../Elements/Tooltip/Tooltip'
import { disabledItem, item } from './ActionsItem.css'

interface ActionsItemProps {
  icon?: IconProp
  title: string
  link?: string
  disabled?: boolean
  tooltip?: string
  onClick?: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void
}

export const ActionsItem = ({
  icon,
  title,
  link,
  disabled,
  tooltip,
  ...rest
}: ActionsItemProps): ReactElement => {
  const onclick = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>): void => {
    e.stopPropagation()
    if (link !== undefined) {
      window.location.href = link
    }
  }
  return (
    <Tooltip text={tooltip} asChild>
      <span
        className={clsx(item, disabled ? disabledItem : null)}
        onClick={disabled ? undefined : onclick}
        title={title}
        {...rest}
      >
        {icon !== undefined && <FontAwesomeIcon icon={icon} />}
      </span>
    </Tooltip>
  )
}
